import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as lines from '../../Helpers/LinesHelper';


const ProductParametersWrapper = styled.div`
  width: 100%;
  max-width: 256px;
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 220px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 140px;
  }
`;

const ParameterPair = styled.div`
  height: ${(props) => lines.getLineHeightDesktop(props.lineLength)}px;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  margin: 5px 0 5px 0px;
  padding: 5px 40px 5px 10px;
  border-left: 5px solid rgb(224,224,224);

  @media (max-width: 1239px) { 
    height: ${(props) => lines.getLineHeight1239(props.lineLength)}px;
  }

  @media ${(props) => props.theme.breakpoints.tablet} {
    height: ${(props) => lines.getLineHeightTablet(props.lineLength)}px;
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 5px 11px 5px 5px;
    height: ${(props) => lines.getLineHeightMobile(props.lineLength)}px;
  }
`;

const ParameterPairSelected = styled.div`
  height: ${(props) => lines.getLineHeightDesktop(props.lineLength)}px;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  margin: 5px 0 5px 0;
  padding: 5px 40px 5px 10px;
  background-color: #f5f7fd;
  border-left: 5px solid rgb(72, 85, 160);
  
  @media (max-width: 1239px) { 
    height: ${(props) => lines.getLineHeight1239(props.lineLength)}px;
  }
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    height: ${(props) => lines.getLineHeightTablet(props.lineLength)}px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 5px 11px 5px 5px;
    height: ${(props) => lines.getLineHeightMobile(props.lineLength)}px;
  }
`;

const ParameterPairKey = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  color: #333333;
`;

const ParameterPairValue = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
`;

const ProductParameters = ({
  parameters, lineLengths
}) => (
  <ProductParametersWrapper>
    {parameters.map((parameter, index) => {
      if (parameter.highlighted) {
        return (
          <React.Fragment key={parameter.label}>
            <ParameterPairSelected key={parameter.label} lineLength={lineLengths[index]}>
              <ParameterPairKey>{parameter.label}</ParameterPairKey>
              <ParameterPairValue>{parameter.value}</ParameterPairValue>
            </ParameterPairSelected>
          </React.Fragment>
        );
      }
      return (
        <React.Fragment key={parameter.label}>
          <ParameterPair key={parameter.label} lineLength={lineLengths[index]}>
            <ParameterPairKey>{parameter.label}</ParameterPairKey>
            <ParameterPairValue>{parameter.value}</ParameterPairValue>
          </ParameterPair>
        </React.Fragment>
      );
    })}
  </ProductParametersWrapper>
);

ProductParameters.propTypes = {
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      highlighted: PropTypes.bool.isRequired
    })
  ).isRequired,
  lineLengths: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default ProductParameters;
